import formatTableJson from '@manage/config/tableComponentParams.js'
import { YNColor } from '@manage/config/StateColorEmun'
export default formatTableJson([
  {
    filed: 'assetNumber',
    label: '设备SN码'
  },
  {
    filed: 'excSituation',
    label: '异常类型'
  },
  {
    filed: 'stateStr',
    label: '报警状态',
    type: 'tag',
    colorList: YNColor,
    width: 80
  },
  {
    filed: 'startTime',
    label: '报警时间',
    type: 'time',
    width: '170'
  },
  {
    filed: 'endTime',
    label: '报警消除时间',
    type: 'time',
    width: '170'
  }
])
